import { Button } from '@material-ui/core';
import { GenericHeader, SearchBar } from 'components';
import ListComp from 'components/ListComp';
import React from 'react';
import { Lesson } from 'services';
import { curriculum_manager } from 'utils/constants';
import Results from './Results';
import CreateModal from './CreateModal';

const LessonList = props => {

  const Head = props => {
    let { handleCreateOpen, ...rest } = props; // eslint-disable-line
    return (
      <GenericHeader header="All Lessons" subheader="Lesson Management" {...rest} >
        <Button color="primary" onClick={handleCreateOpen} variant="contained">
          Add Lesson
        </Button>
      </GenericHeader>
    );
  }

  return (
    <ListComp
      listing={Lesson.list}
      title="Lessons"
      name="lessons"
      searchable
      SearchBar={SearchBar}
      Header={Head}
      Results={Results}
      CreateComp={CreateModal}
      roles={[curriculum_manager]}
      filters={{ limit: 10, offset: 0, count: 0, search: "", type: "" }}
    />
  );
};

export default LessonList;
